export const moduleNames = {
  membership: 'Membership'
};

export const DEFAULT_DATABASE_UTC_DATES = [
    '0001-01-01T00:00:00Z',
    '0001-01-01T00:00:00.000Z',
    '0001-01-01T00:00:00'
];
